import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flow } from 'signup-constants/Flow';
import styled from 'styled-components';
import { H1 } from 'UIComponents/elements/headings';
import { getFlowKey } from '../routing/getFlowKey';
import { isSoftwareSignup } from '../store/flow/selectors';
import { devices } from '../styles/viewports.styles';
import { getIntegrationName } from '../utils/getIntegrationName';
import { OptionalFormattedMessage } from '../views-components/OptionalFormattedMessage';
import { Step } from '../views/Step';
import { getLandingPageTitle } from './getLandingPageText';
import { TrackWhen, useExperiment } from '../experiments/useExperiment';
import { ExperimentKeys } from '../experiments/ExperimentKeys';
import { ExperimentParameterGroup } from '../experiments/ExperimentParameterGroup';
import { StepSubtitle } from '../views-components/StepSubtitle';
import { useSelector } from 'react-redux';
import { isInACQ142VariantBCRM } from '../experiments/gswhV1/gswhUtils';
export const StyledH1 = styled(H1).withConfig({
  displayName: "LandingPageTitle__StyledH1",
  componentId: "rshrji-0"
})(["font-size:2.25rem;", " ", " @media ", "{margin-top:40px;", "}@media ", "{margin-top:", ";}"], props => (props.flowKey === Flow.Connect || props.flowKey === Flow.ChatSpot) && `font-size: 1.75rem;`, props => props.theme.embedded && ` margin-top: 0;
      font-size: 1.75rem;`, devices.tablet, props => (props.isFramedCentredStep || props.isACQ142VariantB) && ` margin-top: 0;`, devices.desktop, props => props.isFramedCentredStep ? '20px' : '0');
export const LandingPageSubtitle = styled.div.withConfig({
  displayName: "LandingPageTitle__LandingPageSubtitle",
  componentId: "rshrji-1"
})(["", ""], props => props.theme.embedded && `margin-bottom: 1rem;`);
export const LandingPageTitle = ({
  isMobile,
  isFramedCentredStep = false
}) => {
  const flowKey = getFlowKey();
  const {
    title,
    subtitleLabel
  } = getLandingPageTitle(flowKey);
  const {
    isAssignedToSpecificVariant
  } = useExperiment(ExperimentKeys.ACQ0142, TrackWhen.never);
  const defaultMobileSubtitle = `views.${Step.LandingPage}.mobileSubtitle.default`;
  const subtitle = isMobile && isSoftwareSignup() ? defaultMobileSubtitle : subtitleLabel;
  const isAssignedToACQ142VariantB = isAssignedToSpecificVariant(ExperimentParameterGroup.Variant_B);
  const mainTitle = isAssignedToACQ142VariantB ? `views.${Step.LandingPage}.title.acq142.variant_b` : title;
  const isACQ142VariantBCRM = useSelector(isInACQ142VariantBCRM);

  const getSubtitle = () => {
    if (isACQ142VariantBCRM) {
      return /*#__PURE__*/_jsx(StepSubtitle, {
        message: `views.${Step.LandingPage}.preTitle.acq142.variant_b_crm`
      });
    }

    return /*#__PURE__*/_jsx(StepSubtitle, {
      message: `views.${Step.LandingPage}.preTitle.acq142.variant_b`
    });
  };

  return /*#__PURE__*/_jsxs("div", {
    className: "text-center m-x-auto flex-column justify-center",
    children: [isAssignedToSpecificVariant(ExperimentParameterGroup.Variant_B) && getSubtitle(), /*#__PURE__*/_jsx(StyledH1, {
      flowKey: flowKey,
      isACQ142VariantB: isAssignedToACQ142VariantB,
      isFramedCentredStep: isFramedCentredStep,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: mainTitle,
        options: {
          integratorName: getIntegrationName()
        }
      })
    }), /*#__PURE__*/_jsx(LandingPageSubtitle, {
      children: /*#__PURE__*/_jsx(OptionalFormattedMessage, {
        message: subtitle
      })
    })]
  });
};